import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import styles from './index.module.css';
import UserRoutes from "../../routes/UserRoutes";
import LogoImg from '../../assets/images/brand/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faClose } from "@fortawesome/free-solid-svg-icons";

const Sidebar = ({ isSidebarOpen, closeSidebar }) => {
    const navigate = useNavigate();
    const slicedRoutes = UserRoutes.slice(0, 4);

    return (
        <>
            <div className={`${styles.sideBarContainer} ${isSidebarOpen ? styles.showSidebar : styles.hideSidebar
                }`}>
                <div className={styles.headingSec}>
                    <div className={styles.logoSec}>
                        <img src={LogoImg} alt="Logo" className={styles.logoImg} />
                    </div>
                    <div className={styles.topSec}>
                        <div className={styles.barIcon} onClick={closeSidebar}>
                            <FontAwesomeIcon icon={faClose} size="lg" style={{ color: '#FFFFFF', marginTop: '0px' }} />
                        </div>
                    </div>
                </div>
                <ul className={styles.sidebarMenu}>
                    {slicedRoutes.map((item) => (
                        <li key={item.name}>
                            <NavLink to={item.path} className={({ isActive }) => isActive ? styles.active : ""}>
                                {item.name}
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default Sidebar;
